import link from "@/scripts/host";

export default {
  name: 'NewSongs',
  data(){
    return {
      newSongs: null,
      songsElements: 4,
      showAll: true
    }
  },
  computed: {
    songs() {
      return this.newSongs;
    },
    songEl() {
      return this.songsElements;
    }
  },
  methods: {
    playMP3(mp3) {
      this.$emit('songURL', mp3);
    },
    goToArtistSite(id) {
      if(!this.$route.path.includes('artysta')){
        this.$router.push(`/artysta/${id}`)
      }
    },
    goToSong(id) {
      if(!this.$route.path.includes(`/utwór/${id}`)){
        this.$router.push(`/utwór/${id}`)
      }
    },
    showAllSongs(){
      this.songsElements = this.newSongs.length;
      this.showAll = false;
    }
  },
  props: ['listNumber', 'actualPlay', 'isPlaying'],
  mounted() {
    this.axios.get(`${link.hostLink}SongList/GetNewSongsOnList?TypeId=${this.listNumber}`).then((response)=>{
      if(response.data.length > 0){
        this.newSongs = response.data;
      }
    })
  }
}
